<template>
    <div class="panel panel-default">
        <div class="panel-heading">
                {{ $t("legal:extract")}}: {{sourceRealEstateDisplay}}
                <!-- {{legal_status.real_estate.re_key}} - {{legal_status.real_estate.address}} -->
                <span
                    v-if="legal_status.legal_file !== null"
                    class="btn btn-xs btn-outline btn-rounded btn-info view-pdf m-l-10" 
                    :href="legal_status.legal_file"
                    :data-title="legal_status.name"
                >
                    {{ $t("legal:look_pdf")}}
                </span>
                <a
                    v-else
                    class="btn btn-xs btn-outline btn-rounded btn-info m-l-10"
                    :href="manual_search_link"
                    target="_blank"
                >
                    {{ $t("legal:manual_search:text") }}
                </a>
                <span
                    v-if="current_user && current_user.is_superuser"
                    class="btn btn-xs btn-outline btn-rounded btn-info m-l-10" 
                    @click="parseLegalStatus"
                >
                    {{  $t("legal:refresh_owners") }}
                    <div>(vidno samo administratorjem)</div>
                </span>
                <br />
                <!-- <span
                    class="text-danger small custom-cursor-pointer"
                    v-tooltip="`${$t('legal:reset_for')}: ${sourceRealEstateDisplay}`"
                    @click="$emit('delete-legal-status', legal_status.id)"
                >
                    {{ $t("legal:reset") }}
                </span> -->
            <div class="panel-action">
                <a href="#" data-perform="panel-collapse"><i class="ti-minus"></i></a> 
            </div>
        </div>
        <div class="panel-wrapper collapse in vld-parent">

            <loading 
                :active="loading_legal_status"
                :can-cancel="false" 
                :is-full-page="false"
            />

            <div class="panel-body p-t-10">
                <div class="m-b-20" v-if="property_analysis && property_analysis.custom_unit_id_for_zk">
                    <legal-share-selector
                        :property_analysis="property_analysis"
                        :session_id="session_id"
                        @shares-updated="onSharesUpdated"
                    />
                </div>

                <p>{{  $t("legal:zk_date") }} {{legal_status.created}}.</p>

                <div :class="{'col-md-4': !alignContentInColumn, 'col-md-12': alignContentInColumn }">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{  $t("depository:owner_title").toUpperCase() }}</th>
                                <th>{{  $t("depository:share").toUpperCase() }}</th>
                                <th v-if="detailsVisible">{{ $t("legal:details").toUpperCase() }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(owner, idx) in displayedLegalOwners" :key="'lowner_'+idx">
                                <td>{{idx+1}}</td>
                                <td>
                                    <span class="text-muted">{{owner.ownership_type}}</span><br>
                                    <span class="font-medium">{{owner.full_name}}</span><br>
                                    <span v-if="owner.address && owner.address != 'None'" class="text-muted">{{owner.address}}</span>
                                    <div class="m-t-10" v-if="config.LEGAL_OWNER_RATING_ENABLED">
                                        <span v-if="owner.rating" class="text-muted">
                                            <div
                                                type="button"
                                                class="btn btn-circle"
                                                :class="'btn-'+owner.rating.css"
                                                v-tooltip="owner.rating.name"
                                            >
                                                {{ owner.rating.label }}
                                            </div>
                                            <span v-if="owner.rating.note" > - {{ owner.rating.note }}</span>
                                        </span>

                                        <span class="m-l-10 recreate-rating-icon" @click="recreateOwnerRating(owner)">
                                            <i v-tooltip="'Avtomatsko določi oceno tveganja'" class="fa fa-refresh text-muted"></i>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <span
                                        class="label label-success label-rouded"
                                        :class="{'label-success': owner.share.includes('1/1'), 'label-warning': !owner.share.includes('1/1')}"
                                    >
                                        {{owner.share}}
                                    </span>
                                </td>
                                <td v-if="detailsVisible">
                                  <span class="text-muted">{{owner.details}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="hasMoreOwners && !show_all_owners" class="text-center m-t-10">
                        <button 
                            class="btn btn-xs btn-outline btn-rounded btn-info"
                            @click="show_all_owners = true"
                        >
                            {{ $t("general:show") }} {{ legal_status.legal_owners.length }} {{ $t("legal:legal_owners") }}
                        </button>
                    </div>
                    <div v-if="hasMoreOwners && show_all_owners" class="text-center m-t-10">
                        <button 
                            class="btn btn-xs btn-outline btn-rounded btn-info"
                            @click="show_all_owners = false"
                        >
                            {{ $t("legal:show_only_first_10_legal_owners") }}
                        </button>
                    </div>
                </div>

                <div :class="{'col-md-8': !alignContentInColumn, 'col-md-12': alignContentInColumn }">
                    <div v-if="!legal_status.data">
                        {{ $t("legal:error_messages:zk_parsing_failed") }}
                        <span v-if="legal_status.legal_file">
                            {{ $t("legal:info_messages:open_document") }}
                            <span
                                class="btn btn-xs btn-outline btn-rounded btn-info view-pdf m-l-10" 
                                :href="legal_status.legal_file"
                                :data-title="legal_status.name"
                            >
                              {{ $t("legal:look_pdf")}}
                            </span>
                        </span>
                    </div>

                    <div v-else-if="legal_status.legal_items.length" class="table-responsive">
                        
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ $t("legal:fact").toUpperCase() }}</th>
                                    <th>{{ $t("legal:details").toUpperCase() }}</th>
                                    <th class="text-nowrap">{{ $t("legal:risk_assessment").toUpperCase()}}</th>
                                    <!-- <th>UREDI</th> -->
                                </tr>
                            </thead>
                            <tbody v-if="!legal_status.legal_items.length">
                                <tr>
                                    <td class="text-center" colspan="3">
                                      {{ $t("legal:no_legal_restrictions")}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <template v-for="(legal_item, idx) in displayedLegalItems">
                                    <tr>
                                        <td>
                                            {{legal_item.name}}
                                        </td>
                                        <td>
                                            {{legal_item.note}}

                                            <!-- Show processing status for plombe -->
                                            <div v-if="legal_item.plombe_processing_status === 'in_progress'" class="m-t-5">
                                                <span class="label label-warning">
                                                    <i class="fa fa-spinner fa-spin"></i> Pridobivam priloge...
                                                </span>
                                            </div>

                                            <!-- Show button for not_retrieved plomba items -->
                                            <div v-if="legal_item.plombe_processing_status === 'retrieve_on_demand'" class="m-t-5">
                                                <button 
                                                    class="btn btn-xs btn-outline btn-rounded btn-warning"
                                                    @click="processPlombaOnDemand(legal_item)"
                                                >
                                                    {{ $t("legal:fetch_attachments") }}
                                                </button>
                                            </div>

                                            <ul v-if="legal_item.attachments.length" class="custom-unstyled-list m-t-5 p-0">
                                                <span class="font-medium">Priloge:</span>
                                                <li v-for="(attachment, attachment_idx) in legal_item.attachments" :key="'litem-'+idx+'-attachment-'+attachment_idx">
                                                    - {{attachment.name}}
                                                    <a v-if="attachment.pdf_file !== null" :href="attachment.pdf_file" :data-title="attachment.name" v-tooltip="$t('legal:look_pdf')">
                                                        <i class="fa fa-file-pdf-o"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="text-center">
                                            <legal-rating-selector
                                                v-if="legal_item.rating"
                                                v-model="legal_item.rating"
                                                :rating_choices="legal_rating_choices"
                                                :rating_edited="legal_item.rating_edited"
                                                :enable_dropdown="legal_rating_choices.length > 0"
                                                @select="updateLegalItem(legal_item)"
                                                @recreate-rating-click="recreateRating(legal_item)"
                                            />
                                        </td>
                                        <!-- <td class="text-center">
                                            <i v-tooltip="'Uredi opombo'" class="fa fa-pencil text-inverse"></i>
                                        </td> -->
                                    </tr>
                                    <tr v-for="(child_legal_item, child_idx) in legal_item.child_legal_items" :key="'litem-'+idx+'-details-tr-'+child_idx">
                                        <td style="border-top: none;"></td>
                                        <td>
                                            {{child_legal_item.name}} - {{child_legal_item.note}}
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <div v-if="hasMoreLegalItems && !show_all_legal_items" class="text-center m-t-10">
                            <button 
                                class="btn btn-xs btn-outline btn-rounded btn-info"
                                @click="show_all_legal_items = true"
                            >
                                {{ $t("general:show") }} {{ legal_status.legal_items.filter(i => !i.parent_item).length }} {{ $t("legal:legal_details") }}
                            </button>
                        </div>
                        <div v-if="hasMoreLegalItems && show_all_legal_items" class="text-center m-t-10">
                            <button 
                                class="btn btn-xs btn-outline btn-rounded btn-info"
                                @click="show_all_legal_items = false"
                            >
                                {{ $t("legal:show_only_first_10_legal_details") }}
                            </button>
                        </div>
                    </div>

                </div>

                <div class="col-md-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>GURS</th>
                                <th>ZK</th>
                                <th>Ujemanje</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>ID znak</th>
                                <td>
                                    <!-- Display parcel_id if available, otherwise show re_key -->
                                    <template v-if="legal_status.data && legal_status.data.metadata && legal_status.data.metadata.parcel_id">
                                        {{ legal_status.data.metadata.parcel_id }}
                                    </template>
                                    <template v-else>
                                        {{ legal_status.real_estate.re_key }}
                                    </template>
                                </td>
                                <td>{{ getZKReKey(legal_status.data["NEPREMICNINA"]["id_znak"]) }}</td>
                                <td>
                                    <i class="fa fa-check text-success"></i>
                                </td>
                            </tr>
                            <tr v-if="legal_status.data['NEPREMICNINA']['naslov'] && legal_status.real_estate.address">
                                <th>Naslov</th>
                                <td>{{ legal_status.real_estate.address }}</td>
                                <td>{{ legal_status.data["NEPREMICNINA"]["naslov"] }}</td>
                                <td>
                                    <i class="fa fa-check text-success"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import configmixin from "@/mixins/configmixin";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import ApiService from "@/components/utils/api.service.js";

import LegalRatingSelector from "./LegalRatingSelector"
import LegalShareSelector from "./LegalShareSelector.vue"

export default {
    mixins: [configmixin],
    components: {
        Loading,
        LegalRatingSelector,
        LegalShareSelector,
    },
    model: {
        prop: 'legal_status',
        event: 'change'
    },
    props: {
        legal_status: {
            type: Object,
            required: true
        },
        current_user: {
            type: Object,
            required: false,
        },
        manual_search_link: {
            type: String,
            required: true,
        },
        session_id: {
            type: Number,
            required: false,
        },
        property_analysis: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            legal_rating_choices: [],
            loading_legal_status: false,
            polling_intervals: {}, // Track polling intervals for individual items
            show_all_owners: false,
            show_all_legal_items: false,
        }
    },
    methods: {
        getZKReKey(id_znak) {
            // Replace "parcela" and "del stavbe" with nothing. Replace leading and trailing spaces. Then split by " " and join with "-"
            return id_znak.replace("parcela", "").replace("del stavbe", "").replace(/^\s+|\s+$/g, "").split(" ").join("-");
        },
        parseLegalStatus() {
            this.loading_legal_status = true;
            ApiService
                .get("/amas/analysis/legal/api/legal-status/" + this.legal_status.id + "/?parse=true")
                .then(response => {
                    this.$emit("change", response.data);
                    // Start polling for any new plombe items that might have been created
                    this.$nextTick(() => {
                        this.startPolling();
                    });
                })
                .then(() => {
                    this.loading_legal_status = false;
                })
        },
        getLegalRatingChoices() {
            ApiService
                .get("/amas/analysis/legal/api/legal-rating/list/public")
                .then(response => {
                    this.legal_rating_choices = response.data;
                })
        },
        _handleLegalItemUpdate(data) {
            this.legal_status.legal_items
                .filter(i => i.id===data.id)
                .map(i => {
                    i.rating = data.rating;
                    i.rating_edited = data.rating_edited;
                    i.user_note = data.user_note;
                    return i
                })
            this.$emit("change", this.legal_status);
        },
        _handleLegalOwnerUpdate(data) {
            this.legal_status.legal_owners
                .filter(o => o.id===data.id)
                .map(o => {
                    o.rating = data.rating;
                    o.rating_edited = data.rating_edited;
                    return o
                })
            this.$emit("change", this.legal_status);
        },
        updateLegalItem(legal_item) {
            ApiService
                .put(
                    "/amas/analysis/legal/api/legal-item/" + legal_item.id + "/",
                    legal_item
                )
                .then(response => {
                    this._handleLegalItemUpdate(response.data);
                })
        },
        recreateRating(legal_item) {
            ApiService
                .get("/amas/analysis/legal/api/legal-item/" + legal_item.id + "/?recreate_rating=true")
                .then(response => {
                    this._handleLegalItemUpdate(response.data);
                    this.$notify({
                        group: "warn",
                        type: "success",
                        text: this.$t("legal:legal_rating_refreshed"),
                    });
                })
        },
        recreateOwnerRating(owner) {
            ApiService
                .get("/amas/analysis/legal/api/legal-owner/" + owner.id + "/?recreate_rating=true")
                .then(response => {
                    this._handleLegalOwnerUpdate(response.data);
                })
        },
        getPlombeItemsInProgress() {
            return this.legal_status.legal_items.filter(item => 
                item.plombe_processing_status === 'in_progress'
            );
        },
        startPollingForItem(legal_item) {
            // Stop existing polling for this item if any
            this.stopPollingForItem(legal_item.id);
            
            // Only start polling if item is actually in progress
            if (legal_item.plombe_processing_status === 'in_progress') {
                this.polling_intervals[legal_item.id] = setInterval(() => {
                    this.checkItemStatus(legal_item.id);
                }, 3000); // Poll every 3 seconds
            }
        },
        stopPollingForItem(itemId) {
            if (this.polling_intervals[itemId]) {
                clearInterval(this.polling_intervals[itemId]);
                delete this.polling_intervals[itemId];
            }
        },
        stopAllPolling() {
            Object.keys(this.polling_intervals).forEach(itemId => {
                this.stopPollingForItem(itemId);
            });
        },
        startPolling() {
            // Start polling for all plombe items that are in progress
            this.getPlombeItemsInProgress().forEach(item => {
                this.startPollingForItem(item);
            });
        },
        checkItemStatus(itemId) {
            ApiService
                .get("/amas/analysis/legal/api/legal-item/" + itemId + "/")
                .then(response => {
                    const updatedItem = response.data;
                    
                    // Update the specific item in the legal_status
                    const itemIndex = this.legal_status.legal_items.findIndex(item => item.id === itemId);
                    if (itemIndex !== -1) {
                        // Update only the changed properties
                        this.$set(this.legal_status.legal_items, itemIndex, {
                            ...this.legal_status.legal_items[itemIndex],
                            plombe_processing_status: updatedItem.plombe_processing_status,
                            attachments: updatedItem.attachments
                        });
                        
                        // Stop polling if item is completed
                        if (updatedItem.plombe_processing_status === 'completed') {
                            this.stopPollingForItem(itemId);
                        }
                    }
                    
                    // Emit change event to notify parent
                    this.$emit("change", this.legal_status);
                })
                .catch(error => {
                    // Continue polling even if there's an error
                })
        },
        processPlombaOnDemand(legal_item) {
            const itemIndex = this.legal_status.legal_items.findIndex(item => item.id === legal_item.id);
            if (itemIndex !== -1) {
                this.$set(this.legal_status.legal_items, itemIndex, {
                    ...this.legal_status.legal_items[itemIndex],
                    plombe_processing_status: "in_progress",
                    attachments: legal_item.attachments
                });
            }

            ApiService
                .post(`/amas/analysis/legal/api/legal-item/${legal_item.id}/process-plomba/`)
                .then(response => {
                    this._handleLegalItemUpdate(response.data.legal_item);
                    this.$nextTick(() => {
                        this.startPollingForItem(legal_item);
                    });
                })
                .catch(() => {
                    this.$notify({
                        group: "warn",
                        type: "error",
                        text: this.$t("legal:error_processing_individual_plomba"),
                    });
                })
        },
        onSharesUpdated(responseData) {
            this.$emit("shares-updated", responseData);
        }
    },
    watch: {
        legal_status: {
            handler(newVal, oldVal) {
                // Stop all existing polling and start fresh
                this.$nextTick(() => {
                    this.stopAllPolling();
                    this.startPolling();
                });
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        detailsVisible() {
            if (this.legal_status) {
                for (const owner of this.legal_status.legal_owners)
                    if (owner.details)
                        return true;
            }
            return false;
        },
        alignContentInColumn() {
            if (this.detailsVisible)
                return true;
            return (this.legal_status.legal_items.length === 0);
        },
        sourceRealEstateDisplay() {
            let res;
            if (this.legal_status && this.legal_status.data && this.legal_status.data["NEPREMICNINA"] &&
                this.legal_status.data["NEPREMICNINA"]["id_znak"] !== undefined) {
                let raw = this.legal_status.data["NEPREMICNINA"]["id_znak"];
                if ( raw ) {
                    if( raw.includes("parcela") ) { // parcela 1920 211
                        let re = /parcela ([0-9/*]+) ([0-9/*]+)/;
                        res = "parcela " + raw.match(re).splice(1).join("-");
                    } else { // del stavbe 1772-1627-32
                        // re = /del stavbe (\d+)-(\d+)-(\d+)/;
                        res = raw;
                    }
                }
            } else if (this.legal_status && this.legal_status.real_estate) {
                res = this.legal_status.real_estate.re_key;
            }
            return res;            
        },
        displayedLegalOwners() {
            if (!this.legal_status || !this.legal_status.legal_owners) return [];
            return this.show_all_owners ? this.legal_status.legal_owners : this.legal_status.legal_owners.slice(0, 10);
        },
        displayedLegalItems() {
            if (!this.legal_status || !this.legal_status.legal_items) return [];
            const filteredItems = this.legal_status.legal_items.filter(i => !i.parent_item).sort((i, j) => i.id - j.id);
            return this.show_all_legal_items ? filteredItems : filteredItems.slice(0, 10);
        },
        hasMoreOwners() {
            return this.legal_status && this.legal_status.legal_owners && this.legal_status.legal_owners.length > 10;
        },
        hasMoreLegalItems() {
            const filteredItems = this.legal_status && this.legal_status.legal_items ? 
                this.legal_status.legal_items.filter(i => !i.parent_item) : [];
            return filteredItems.length > 10;
        }
    },
    mounted() {
        this.getLegalRatingChoices();
        this.startPolling();
    },
    beforeDestroy() {
        this.stopAllPolling();
    }
}
</script>

<style scoped>
.recreate-rating-icon {
    cursor: pointer;
}
</style>